import type { InferOutput } from 'valibot'
import { array, boolean, nullish, object, optional, pipe, string, transform, union } from 'valibot'
import { collationDetailSchema, suggestionDetailSchema, transformCollations, transformSuggestions } from './spellcheck-utils'

const suggestionsSchema = pipe(
  array(union([string(), suggestionDetailSchema])),
  transform(transformSuggestions),
)

const collationsSchema = pipe(
  array(union([string(), collationDetailSchema])),
  transform(transformCollations),
)

export const spellcheckResponseSchema = object({
  suggestions: nullish(suggestionsSchema),
  correctlySpelled: nullish(boolean()),
  collations: optional(collationsSchema),
})

export type SpellcheckResponse = InferOutput<typeof spellcheckResponseSchema>
export type Collation = InferOutput<typeof collationDetailSchema>
